"use client";

import { talentNetworkText } from "@/i18n/talentNetwork.constants";

import { BottomSheet } from "@artha/ui";
import { X } from "lucide-react";
import {
  PERSONALIZATION_SHEET_CONTENT_CLASS_NAME,
  PERSONALIZATION_SHEET_OVERLAY_CLASS_NAME,
} from "../../../personalization.constants";
import { PROFILE_EDITOR_CLOSE_CLASS_NAME } from "../profileCards.constants";
import type { ProfileEditorPopupProps } from "../profileCards.types";

export function ProfileEditorPopup({
  isOpen,
  title,
  error,
  saving,
  onClose,
  children,
}: ProfileEditorPopupProps) {
  return (
    <BottomSheet
      isOpen={isOpen}
      onClose={() => {
        if (!saving) onClose();
      }}
      title={title}
      variant="details"
      contentClassName={PERSONALIZATION_SHEET_CONTENT_CLASS_NAME}
      overlayClassName={PERSONALIZATION_SHEET_OVERLAY_CLASS_NAME}
      headerAction={
        <button
          type="button"
          aria-label={talentNetworkText("close_editor")}
          className={PROFILE_EDITOR_CLOSE_CLASS_NAME}
          disabled={saving}
          onClick={onClose}
        >
          <X aria-hidden="true" className="h-4 w-4" />
        </button>
      }
    >
      {isOpen ? (
        <>
          {error ? (
            <p role="alert" className="mb-4 text-sm text-[#B42318]">
              {error}
            </p>
          ) : null}
          {saving ? (
            <p role="status" className="mb-4 text-sm text-[#475467]">
              {talentNetworkText("saving_profile")}
            </p>
          ) : null}
          <fieldset disabled={saving} aria-busy={saving} className="min-w-0">
            {children}
          </fieldset>
        </>
      ) : null}
    </BottomSheet>
  );
}
